module.exports = __webpack_public_path__ + "img/supplier.f8647f65.svg";